<!-- @format -->

<ng-container *transloco="let t">
  <nav *ngIf="showBreadcrumbs" [attr.aria-label]="t('ARIA_LABEL.BREADCRUMBS')" class="sis-mb-md">
    <ol class="breadcrumb">
      <li *ngIf="breadcrumbs.length > 1 || showHomeNode === true" class="home">
        <a fudisLink [title]="t('SIS_COMPONENTS.BREADCRUMB.HOME')" [href]="homeUrl"></a>
        <sis-icon icon="chevron"></sis-icon>
      </li>
      <ng-container *ngFor="let item of breadcrumbs; last as isLast">
        <li *ngIf="!isLast">
          <a fudisLink *ngIf="item.isLink" [title]="item.displayName" [uiSref]="item.route"></a>
          <span *ngIf="!item.isLink">{{ item.displayName }}</span>
          <sis-icon icon="chevron"></sis-icon>
        </li>
        <li *ngIf="isLast && showLastNode === true" aria-current="page">{{ item.displayName }}</li>
        <li *ngIf="isLast && showLastNode === false" class="visually-hidden" aria-current="page">{{ item.displayName }}</li>
      </ng-container>
    </ol>
  </nav>
</ng-container>
